module.exports = __webpack_public_path__ + "img/jiushui1.ca99b9a0.png";